var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatelesisLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.393,
    height: 111.436,
    viewBox: "0 0 85.393 111.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4839 717.348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.232,10.357C35.966,6.885,41.025,2.707,50.3.031c0,0-20.562-1.513-26.484,16.8a25.622,25.622,0,0,1,9.417-6.475",
    transform: "translate(4836.15 -717.348)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.775,9.576c2.645-1.336,8.517-2.949,19.7-.279,0,0-11.554-10-28.894.165a26.071,26.071,0,0,1,9.191.114",
    transform: "translate(4834.144 -717.934)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,24.608s-5.625-12.073-21.671-11.6a25.62,25.62,0,0,1,5.97,4.3c4.253.577,9.709,2.456,15.7,7.3",
    transform: "translate(4831.93 -718.903)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.474,44.542s3.191-14-12.142-21.089a24.544,24.544,0,0,1,2.924,6.961c2.764,2.127,6.243,6.226,9.218,14.128",
    transform: "translate(4830.583 -720.154)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.157,33.992a24.547,24.547,0,0,1,5.513-15.5c.108-4.516.834-10.81,3.733-14.6,0,0-11.888,3.02-11.134,23.589,0,0-4.152-3.4-5.1-8.3,0,0-5.1,11.7,6.982,23.778,0,0-5.473-.378-9.059-2.83,0,0,5.113,12.96,18.208,13.028a24.733,24.733,0,0,1-9.148-19.161",
    transform: "translate(4838.271 -717.814)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.536,46.214c1.28,4.059,1.519,9.633-1.916,16.418,0,0,13.255-6.291,3.313-26.777.051.648.085,1.3.085,1.962a24.452,24.452,0,0,1-1.482,8.4",
    transform: "translate(4830.549 -721.638)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.959,61.342s5.742,7.98,23.375,4.4A25.776,25.776,0,0,1,27.308,61.39a23.239,23.239,0,0,1-11.349-.048",
    transform: "translate(4837.09 -724.688)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.625,65.947c-.189,0-.376-.01-.565-.014a34.707,34.707,0,0,1-12.74,4.921s14.5,4.322,26.843-8.128c.1-.258.193-.507.272-.744a25.863,25.863,0,0,1-13.81,3.965",
    transform: "translate(4835.372 -724.765)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.942,59.854a6.67,6.67,0,0,1-1.122.747,22.329,22.329,0,0,1-9.564,10.948s17.539-.736,18.785-21.111a25.253,25.253,0,0,1-8.1,9.416",
    transform: "translate(4832.986 -723.383)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.287,83.532H46.841v5.583H67.633c3.947,0,3.708,2.362,3.708,2.362v2.505a3.249,3.249,0,0,0-2.575-1.294H49.926a2.948,2.948,0,0,0-3.085,2.539v9.428c0,1.917,2.308,2.261,2.308,2.261H69.066a5.084,5.084,0,0,0,2.623-1v1h6.643v-16.7c.04-7.118-6.044-6.684-6.044-6.684m-3.778,18.13H55.085A1.9,1.9,0,0,1,53.576,99.7s.058-1.7,1.509-1.7h13.37s1.664.253,1.664,1.6c0,0,.408,2.065-1.609,2.065",
    transform: "translate(4833.395 -727.343)",
    fill: "#003087",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,89.12l1.607,0h18.2V83.534H15.15l-2.058.014h-1.28S6.117,83.2,6.151,89.14V101.2s-.2,5.655,6.751,5.715H35.5s2.308-.343,2.308-2.261V95.228a2.949,2.949,0,0,0-3.086-2.539H20.155v5.3h9.409c1.45,0,1.508,1.7,1.508,1.7a1.9,1.9,0,0,1-1.508,1.965H17.345a4.3,4.3,0,0,1-3.1-1.524,4.858,4.858,0,0,1-1.159-3.219l-.034-3.969S12.639,89.134,18,89.12",
    transform: "translate(4838.264 -727.344)",
    fill: "#003087",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.981,115.537h6.484v2.238H11.127v7.487H8.981Z",
    transform: "translate(4837.925 -731.174)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.483,115.537H0v2.238H4.338v7.487H6.483Z",
    transform: "translate(4839 -731.174)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.593,121.6c1.728,0,1.76-1.155,1.76-1.155v-2.669c0-2.154-1.729-2.238-1.729-2.238H20.413a2.626,2.626,0,0,0-2.9,2.9v3.731a2.886,2.886,0,0,0,2.419,3.1h9.418v-2.1H21.658c-2.26,0-1.883-1.563-1.883-1.563ZM20.6,117.774h5.621s.672.1.672.671c0,0,.166.86-.65.86H20.6a.784.784,0,0,1-.609-.819s.026-.712.609-.712",
    transform: "translate(4836.905 -731.174)",
    fill: "#003087",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.48,115.537h2.379v6.469a1.214,1.214,0,0,0,1.177,1.157H42v2.1H34.859s-2.379-.22-2.379-2.239Z",
    transform: "translate(4835.113 -731.174)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.432,121.6c1.727,0,1.76-1.155,1.76-1.155v-2.669c0-2.154-1.729-2.238-1.729-2.238H47.252a2.627,2.627,0,0,0-2.9,2.9v3.731a2.887,2.887,0,0,0,2.42,3.1h9.418v-2.1H48.5c-2.259,0-1.882-1.563-1.882-1.563Zm-6.989-3.825h5.621s.671.1.671.671c0,0,.166.86-.649.86H47.443a.784.784,0,0,1-.608-.819s.026-.712.608-.712",
    transform: "translate(4833.693 -731.174)",
    fill: "#003087",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.165,
    height: 9.725,
    transform: "translate(4904.331 -615.637)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.942,115.537h8.85v2.238h-7.4a.508.508,0,0,0-.6.561s-.045.979.644.979h6.949a2.724,2.724,0,0,1,1.292,2.284v1.157s-.117,2.506-1.246,2.506H58.946v-2.1h8.246s.942-.116.942-.769a.939.939,0,0,0-.978-.886H61.138a2.154,2.154,0,0,1-1.585-2.005V116.8s-.142-1.259,1.388-1.259",
    transform: "translate(4831.946 -731.174)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.91,115.537h8.85v2.238h-7.4a.507.507,0,0,0-.594.561s-.047.979.643.979h6.949a2.724,2.724,0,0,1,1.292,2.284v1.157s-.118,2.506-1.247,2.506H77.914v-2.1H86.16s.944-.116.944-.769a.94.94,0,0,0-.98-.886H80.107a2.155,2.155,0,0,1-1.585-2.005V116.8s-.141-1.259,1.388-1.259",
    transform: "translate(4829.676 -731.174)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.92,117.178a1.793,1.793,0,1,1,.884,1.546,1.79,1.79,0,0,1-.884-1.546m.251,0a1.543,1.543,0,0,0,2.316,1.337,1.546,1.546,0,0,0,.565-.563,1.539,1.539,0,0,0,0-1.546,1.546,1.546,0,0,0-.563-.565,1.539,1.539,0,0,0-1.546,0,1.553,1.553,0,0,0-.565.563,1.5,1.5,0,0,0-.209.775m2.273-.435a.578.578,0,0,1-.1.338.6.6,0,0,1-.285.218l.568.944h-.4l-.495-.845h-.322v.845h-.353v-2.128h.623a.9.9,0,0,1,.581.155.584.584,0,0,1,.185.473m-1.036.361h.258a.457.457,0,0,0,.307-.1.318.318,0,0,0,.115-.252.3.3,0,0,0-.1-.257.543.543,0,0,0-.324-.077h-.254Z",
    transform: "translate(4827.88 -731.155)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.392,
    height: 111.436,
    transform: "translate(4839 -717.348)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatelesisLogoBlue);
export default __webpack_public_path__ + "static/media/gatelesis_logo_blue.0b15d720235b9d7ab7f0c7e548dba657.svg";
export { ForwardRef as ReactComponent };